import http from 'common-module/src/util/http';

//用户习惯记录
export async function userHabitRecord(data) {
  const result = await http.post('/account/habit-record', data, { showError: false });
  return { result };
}
//用户习惯查询
export async function userHabitQuery(data) {
  const result = await http.post('/account/habit-query', data, { showError: false });
  return { result };
}

//用户习惯多个查询
export async function userHabitQueryMultiple(data) {
  const result = await http.post('/account/habit-query-multiple', data, { showError: false });
  return { result };
}

// 查询组织产品功能试用详情
export const queryUserTrialDetail = (data) => http.post('/product-trial/query-detail', data);

// 新增试用产品功能
export const addUserTrial = (data) => http.post('/product-trial/add', data);

export async function logout() {
  const result = await http.post('/account/logout');
  return { result };
}

export async function remoteCheckMail(orgEmail) {
  const result = await http.post('/account/check-email', {
    orgEmail
  });
  return { result };
}


export async function sendRegisterMailUser(mail, registerUrl) {
  const result = await http.post('/account/send-register-email/user', {
    mail,
    registerUrl
  });
  return { result };
}
export async function sendRegisterMail(mail, registerUrl) {
  const result = await http.post('/account/send-register-email/company', {
    mail,
    registerUrl
  });
  return { result };
}
/**
 * 获取项目成员在项目中的信息
 * @param projectId 项目ID
 * @returns {Promise<*>}
 */
export const loadMemberProjectInfo = async projectId => {
  return http.post('/member/project-user-info', { projectId });
};

/**
 * 使用临时票据换取token
 * @param ticket
 * @returns {AxiosPromise | Promise<any>}
 */
export const exchangeTokenOfTicket = async ticket => {
  return http.get('/tickets/get-token', { ticket }, { showError: false });
};


/**
 * 使用token换取临时票据
 * @param token
 * @returns {AxiosPromise | Promise<any>}
 */
export const exchangeTicketOfToken = token => http.post('/tickets', {}, {
  showError: false,
  headers: {
    accesstoken: token
  }
});

export const getCurrentUserInfo = async (token) => {
  return http.post('/account/user-info', {}, {
    showError: false,
    headers: {
      accesstoken: token
    }
  });
};

/**
 * 获取当前组织信息
 * @returns {}
 */
export const getCurrentOrgInfo = async (token) => {
  return http.post('/org/org-info', {}, {
    showError: false,
    headers: {
      accesstoken: token
    }
  });
};

/**
 * 获取当前产品线订购权益信息
 * @returns {}
 */
export const getOrgProductRights = async (data, token) => {
  return http.post('/product/get/org-product-right', data, {
    headers: {
      accesstoken: token
    }
  });
};
/**
 * 获取组织的语言
 * @returns {}
 */
export const getOrgLanguage = async (token) => {
  return http.post('/org/get-language', {}, {
    headers: {
      accesstoken: token
    }
  });
};


export const sysPreferenceSwitch = async (data) => {
  return http.post('/meeting/switch', data);
};

export const notifyTimeZoneChanged = async (timezone) => {
  return http.post('/account/change-timezone', { timezone }, { showError: false });
};

/**
 * 获取用户聚合信息：用户信息、组织信息
 * @param token
 * @returns {AxiosPromise | Promise<any>}
 */
export const getUserAssembleInfo = (token) => {
  return http.post('/account/user-org-assemble', {}, {
    showError: false,
    headers: {
      accesstoken: token
    }
  });
};

// 查询用户自定义菜单开启情况
export async function queryAccountConfig() {
  return http.post('/account/query-account-config', {}, {
    showError: false
  });
}

export async function loadProductModuleSupport () {
  return http.post('/product-right/product-module-support-detail', {}, {
    showError: false
  });
}
